import { FieldValues } from "react-hook-form";
import axiosInst from "api/config/axiosConfig";
import {
  allSoftwareDepot,
  currentSoftwareDepot,
  currentSoftwareManualDepot,
  dateSearchResultDepot,
  deviceDetailDepot,
  pendingActionsDepot,
  serialSearchResultDepot,
  softwareRecordsDepot,
  versionSearchResultDepot,
} from "./software.depot";
import dayjs from "dayjs";
import { showWarning } from "utils/notifications";

export async function getSystemSoftwareVer(): Promise<void> {
  const response = await axiosInst.get("/beta/appSystemInfo?swVersion=current");
  currentSoftwareDepot.setData(response.data);
}

export async function getAllSoftwareVer(): Promise<void> {
  const response = await axiosInst.get("/beta/appSystemInfo?swVersion=all");
  allSoftwareDepot.setData(response.data);
}

export async function setSofwareVersion(data: FieldValues) {
  await axiosInst.post("/beta/appSystemInfo", data);
}

export async function getSoftwareRecords(): Promise<void> {
  const response = await axiosInst.get("/beta/appSystemInfo?swVersion=status");
  softwareRecordsDepot.setData(response.data);
}

export async function searchBySerial(serialNumber: string): Promise<void> {
  const response = await axiosInst.get(`/beta/appSystemInfo?serial=${serialNumber}`);
  if (!response.data) {
    throw new Error("The device was not found");
  }
  serialSearchResultDepot.setData(response.data);
}

export async function searchByDate(date1: dayjs.ConfigType, date2: dayjs.ConfigType): Promise<void> {
  const response = await axiosInst.get(`/beta/appSystemInfo?fromDt=${date1}&toDt=${date2}`);
  if (!response.data) {
    throw new Error("No devices were found");
  }
  dateSearchResultDepot.setData(response.data);
}

export async function searchByVersion(versionNumber: string): Promise<void> {
  const response = await axiosInst.get(`/beta/appSystemInfo?autoUpdtVer=${versionNumber}`);
  if (!response.data) {
    throw new Error("No devices were found");
  }
  versionSearchResultDepot.setData(response.data);
}

// MANUAL UPDATE

export async function getAvailableSoftware(serialNumber: string): Promise<void> {
  const response = await axiosInst.get(`/beta/eiStatusUIHook?serialNumber=${serialNumber}`);
  const { deviceData } = response.data;
  if (!deviceData || !deviceData[0]) {
    throw new Error("No devices were found. Please check your serial number and try again");
  }
  deviceDetailDepot.setData(deviceData[0]);
  currentSoftwareManualDepot.setData(deviceData[0].eiSoftwareVersion);
}

export async function getPendingActions(serialNumber: string): Promise<void> {
  const response = await axiosInst.get(`/beta//pendingActionsUIHook?serialNumber=${serialNumber}`);
  pendingActionsDepot.setData(response.data);
}

export interface DeviceSoftwareDeviceDataTypes {
  serialNumber: string;
  softwareVersion: string;
}

export async function updateDeviceSoftware(deviceData: DeviceSoftwareDeviceDataTypes): Promise<void> {
  await axiosInst.post("/beta/pendingActionsUIHook", deviceData);
  showWarning(
    "Software update in progress. Do not power off your device. Check event log below to see when the software update is complete!",
  );
}
